"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var types_1 = require("./types");
var utils_1 = require("./utils");
var GET = types_1.HTTPMethod.GET;
function doFetchArgs(initialOptions, initialURL, path, method, controller, routeOrBody, bodyAs2ndParam, requestInterceptor) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _this = this;
    var route, url, body, headers, options, requestID;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          utils_1.invariant(!(utils_1.isBodyObject(routeOrBody) && utils_1.isBodyObject(bodyAs2ndParam)), "If first argument of ".concat(method.toLowerCase(), "() is an object, you cannot have a 2nd argument. \uD83D\uDE1C"));
          utils_1.invariant(!(method === GET && utils_1.isBodyObject(routeOrBody)), "You can only have query params as 1st argument of request.get()");
          utils_1.invariant(!(method === GET && bodyAs2ndParam !== undefined), "You can only have query params as 1st argument of request.get()");
          route = function () {
            if (!utils_1.isServer && routeOrBody instanceof URLSearchParams) return "?".concat(routeOrBody);
            if (utils_1.isString(routeOrBody)) return routeOrBody;
            return '';
          }();
          url = "".concat(initialURL).concat(path).concat(route);
          body = function () {
            if (utils_1.isBodyObject(routeOrBody)) return JSON.stringify(routeOrBody);
            if (!utils_1.isServer && (bodyAs2ndParam instanceof FormData || bodyAs2ndParam instanceof URLSearchParams)) return bodyAs2ndParam;
            if (utils_1.isBodyObject(bodyAs2ndParam)) return JSON.stringify(bodyAs2ndParam);
            if (utils_1.isBodyObject(initialOptions.body)) return JSON.stringify(initialOptions.body);
            return null;
          }();
          headers = function () {
            var contentType = (initialOptions.headers || {})['Content-Type'];
            var shouldAddContentType = !!contentType || [types_1.HTTPMethod.POST, types_1.HTTPMethod.PUT].includes(method);
            var headers = Object.assign({}, initialOptions.headers);
            if (shouldAddContentType) {
              // default content types http://bit.ly/2N2ovOZ
              // Accept: 'application/json',
              // roughly, should only add for POST and PUT http://bit.ly/2NJNt3N
              // unless specified by the user
              headers['Content-Type'] = contentType || 'application/json';
            } else if (Object.keys(headers).length === 0) {
              return null;
            }
            return headers;
          }();
          _context2.next = 9;
          return function () {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var opts;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    opts = Object.assign(Object.assign({}, initialOptions), {
                      method: method,
                      signal: controller.signal
                    });
                    if (headers !== null) {
                      opts.headers = headers;
                    } else {
                      delete opts.headers;
                    }
                    if (body !== null) opts.body = body;
                    if (!requestInterceptor) {
                      _context.next = 7;
                      break;
                    }
                    _context.next = 6;
                    return requestInterceptor(opts, initialURL, path, route);
                  case 6:
                    return _context.abrupt("return", _context.sent);
                  case 7:
                    return _context.abrupt("return", opts);
                  case 8:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          }();
        case 9:
          options = _context2.sent;
          // TODO: if the body is a file, and this is a large file, it might exceed the size
          // limit of the key size in the Map
          // used to tell if a request has already been made
          requestID = Object.entries({
            url: url,
            method: method,
            body: options.body || ''
          }).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];
            return "".concat(key, ":").concat(value);
          }).join('||');
          return _context2.abrupt("return", {
            url: url,
            options: options,
            requestID: requestID
          });
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}
exports.default = doFetchArgs;